import axios from './axios';
import qs from 'qs';
import api from './api.mappings';
export class DingTalkApi {
    sign(params) {
        return axios.get(api.dingTalk.sign, {
            params
        });
    }
    login(params) {
        return axios.get(api.dingTalk.login, {
            params
        });
    }
    upload(url, isAddWatermark, locationInfo) {
        return axios.post(api.dingTalk.upload, qs.stringify({ url: url, isAddWatermark: isAddWatermark, locationInfo: locationInfo }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }));
    }
}
